import { render } from "./Logic.vue?vue&type=template&id=31e05e0a"
import script from "./Logic.vue?vue&type=script&lang=js"
export * from "./Logic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__